import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { auth, database } from './firebase';
import { ref, set } from 'firebase/database';

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
  auth_type: 'https'
});

async function signInWithGoogle() {
  try {
    const result = await signInWithPopup(auth, googleProvider);    
    const user = result.user;
    await saveUserToDatabase(user);
    console.log("User signed in and data saved:", user);    
    return user;
  } catch (error) {
    console.error("Error signing in with Google:", {
      code: error.code,
      message: error.message,
      email: error.email,
      credential: error.credential
    });
    throw error;
  }
}

async function saveUserToDatabase(user) {
  const userRef = ref(database, `users/${user.uid}/info`);
  const userData = {
    uid: user.uid,
    displayName: user.displayName,
    email: user.email,
    photoURL: user.photoURL,
    lastLogin: new Date().toISOString()
  };
  await set(userRef, userData);
}

async function logout() {
  try {
    await signOut(auth);
    console.log("User logged out");
  } catch (error) {
    console.error("Error signing out:", error);
  }
}

export { signInWithGoogle, logout };